import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { onboardingFlowCompletedResource } from '@jira/router-resources__software-onboarding/src/onboardingFlowCompletedResource.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectsDirectoryRoute } from '@jira/router-routes__directories-routes/src/projectsDirectoryRoute.tsx';
import { ProjectsDirectorySkeleton } from '@jira/platform__skeletons/src/ui/directories/FiltersDirectorySkeleton.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { ProjectsDirectoryPageEntryPoint } from './common/ProjectsDirectoryPageEntryPoint.tsx';

export const projectsDirectoryRouteEntry: Route = createEntry(projectsDirectoryRoute, () => ({
	group: 'directories',
	entryPoint() {
		return ProjectsDirectoryPageEntryPoint;
	},
	skeleton: ProjectsDirectorySkeleton,
	navigation: {
		menuId: MenuIdProjects,
	},
	resources: [...getNavigationResources(), onboardingFlowCompletedResource],
	ufoName: 'projects-directory-v3',
	supportsPreviewPanel: true,
	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
